/* eslint-disable react-hooks/exhaustive-deps */
"use client";
import { DropdownButton, DropdownItem, Row, Spinner } from "@/utils/bootstrap";
import { useEffect, useState, useMemo } from "react";
import { Link } from "@/app/components/lib/navigation/Link";
import SearchDropdownTitle from "./search-helpers/SearchDropdownTitle";
import SearchResultItem from "./search-helpers/SearchResultItem";
import { useSearchProductsQuery } from "@/api/AppApi/services/product";
import useDebounce from "@/hooks/useDebounce";
import { useSearchParams } from "next/navigation";
import { useTranslation } from "@/hooks/localization/useTranslations";
import useEventTrackers from "@/utils/helpers/pixel-helpers/hooks/useEventTrackers/useEventTrackers";
import { getFbcCookie, getFbpCookie } from "@/utils/functions/cookieOperations";
import { v4 as uuidv4 } from "uuid";
interface Props {
  onBlur?: () => void;
  PC?: boolean;
}
const Search: React.FC<Props> = ({ PC = false, onBlur = () => {} }) => {
  const t = useTranslation();
  const { GTagSearchEventTracher } = useEventTrackers();
  const searchParams = useSearchParams();
  const q = searchParams?.get("q");
  const [searchTerm, setSearchTerm] = useState(q ?? "");
  const [active, setActive] = useState(false);
  const debounedSearchTerm = useDebounce(searchTerm, 300);
  const [showDropdown, setShowDropdown] = useState(false);
  
  const fbc = (getFbcCookie() as string) ?? null;
  const fbp = (getFbpCookie() as string) ?? null;
  const trackingId = useMemo(() => uuidv4(), [debounedSearchTerm]);

  const {
    data: searchRaw,
    isError,
    isLoading,
  } = useSearchProductsQuery({ 
    params: { 
      q: debounedSearchTerm, 
      event_id: trackingId, 
      fbc, 
      fbp 
    } 
  });
  const data = searchRaw?.result;
  const handleBlur = (e: any) => {
    if (searchTerm) return;
    const currentTarget = e.currentTarget;
    setTimeout(() => {
      if (!currentTarget.contains(document.activeElement)) {
        onBlur();
        setActive(false);
      }
    }, 0);
  };
  useEffect(() => {
    if (data) GTagSearchEventTracher(searchTerm, !!data?.length, trackingId);
  }, [data]);
  return (
    <div
      tabIndex={0}
      onBlur={handleBlur}
      onClick={() => setActive(true)}
      className={`search-dropdown ${showDropdown ? "dropped" : ""}`}
    >
      <DropdownButton
        show={showDropdown}
        onToggle={(nextShow) => setShowDropdown(searchTerm ? nextShow : false)}
        variant="outline"
        title={
          <SearchDropdownTitle
            PC={PC}
            active={active}
            setActive={setActive}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            setShowDropdown={setShowDropdown}
          />
        }
      >
        <Row className="m-0 d-flex justify-content-center text-center">
          {isLoading ? (
            <Spinner animation="border" variant="dark" />
          ) : !isError && (!data || data?.length === 0) ? (
            <div className="no-results"> {t.no_results}</div>
          ) : (
            isError && <div>Error</div>
          )}
        </Row>
        {data?.map((product, key) => (
          <div key={key}>
            {key > 0 && <hr />}
            <Link
              prefetch={false}
              href={"/products/" + product.slug}
              skipCheckingForLang
            >
              <DropdownItem as="span" aria-label={product?.name}>
                <SearchResultItem product={product} searchTerm={searchTerm} />
              </DropdownItem>
            </Link>
          </div>
        ))}
      </DropdownButton>
    </div>
  );
};

export default Search;
